// Display labels for Haha (cold brew fridge) values, from the Haha Open Platform enumerations.

const DEVICE_TYPE_LABELS: { [type: string]: string } = {
	SINGLE_DOOR_CABINET: 'Single-door cabinet',
	DYNAMIC_SINGLE_DOOR: 'Smart single-door',
	DYNAMIC_DOUBLE_DOOR: 'Smart double-door',
	DOUBLE_DOOR_CABINET: 'Double-door cabinet',
	MULTI_DOOR_CABINET: 'Multi-door cabinet',
	LARGE_CABINET: 'Large cabinet'
};

const DEVICE_STATUS_LABELS: { [status: string]: string } = {
	NOT_ACTIVE: 'Pending activation',
	ACTIVE: 'Operating',
	FROZEN: 'Frozen',
	RETURNED: 'Returned'
};

const CURRENCY_SYMBOLS: { [code: string]: string } = {
	'109005': '$',
	'109008': 'C$',
	'109006': '€',
	'109007': '£'
};

export function coldBrewDeviceTypeLabel(type: string | null | undefined): string {
	return (type && DEVICE_TYPE_LABELS[type]) || type || '—';
}

export function coldBrewStatusLabel(status: string | null | undefined): string {
	return (status && DEVICE_STATUS_LABELS[status]) || status || 'Unknown';
}

export function coldBrewAmount(amount: string | null | undefined, currencyCode: string | null | undefined): string {
	if (!amount) {
		return '—';
	}
	const value = Number(amount);
	const formatted = Number.isFinite(value) ? value.toFixed(2) : amount;
	return `${(currencyCode && CURRENCY_SYMBOLS[currencyCode]) || ''}${formatted}`;
}

// Whole cents as money, e.g. 1275 → "$12.75" and -425 → "-$4.25".
export function coldBrewCents(cents: number | null | undefined, currencyCode: string | null | undefined): string {
	if (cents === null || cents === undefined || !Number.isFinite(cents)) {
		return '—';
	}
	const symbol = (currencyCode && CURRENCY_SYMBOLS[currencyCode]) || '';
	const text = (Math.abs(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	return `${cents < 0 ? '-' : ''}${symbol}${text}`;
}

export function coldBrewErrorMessage(error: any, fallback: string): string {
	const data = error && error.response && error.response.data;
	return (data && data.message) || (error && error.message) || fallback;
}

export function toFilterId(value: unknown): number | null {
	const candidate = Array.isArray(value) ? value[0] : value;
	if (candidate === null || candidate === undefined || candidate === '') {
		return null;
	}
	const parsed = Number(candidate);
	return Number.isFinite(parsed) ? parsed : null;
}
